import { createSyncClientFlag } from "@/lib/core/client-flags/create-sync-client-flag";

export const useProviderHomeEnabled = createSyncClientFlag({
    param: "providerHome",
    key: "wags.provider-home",
    env: false,
});
